import { Box } from '@mui/joy';
import { ICellEditorParams } from 'ag-grid-community';
import dayjs, { Dayjs } from 'dayjs';
import * as yup from 'yup';

import { DB_DATE_FORMAT } from 'core/constants';
import { FormProvider } from 'core/states';

import { PricingDateFormField } from './PricingDateFormField';

const schema = yup.object({ pricingDate: yup.string().nullable() });

interface IProps extends ICellEditorParams {
  onValueChange: (value: unknown) => void;
}

const PricingDateCellEditorInner = ({ onValueChange, stopEditing }: IProps) => {
  const handleChange = (value: Dayjs | null) => {
    onValueChange(value ? dayjs(value).format(DB_DATE_FORMAT) : null);
    stopEditing();
  };

  return (
    <Box sx={{ width: '100%', minWidth: 160 }}>
      <PricingDateFormField
        label=""
        compact
        onChange={handleChange}
        popperProps={{ className: 'ag-custom-component-popup' }}
      />
    </Box>
  );
};

export const PricingDateCellEditor = (props: IProps) => {
  const defaultValues = {
    pricingDate: props.value ? dayjs(props.value) : null,
  };

  return (
    <FormProvider schema={schema} defaultValues={defaultValues}>
      <PricingDateCellEditorInner {...props} />
    </FormProvider>
  );
};
